import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatCardModule, MatGridListModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ViewPodRetryLogsDialogComponent } from './view-pod-retry-logs-dialog.component';

@NgModule({
    declarations: [
        ViewPodRetryLogsDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        CommonModule,
        MatCardModule,
        MatGridListModule,
        FlexLayoutModule,
        FormsModule
    ],
    entryComponents: [
        ViewPodRetryLogsDialogComponent
    ],
})
export class ViewPodRetryLogsDialogModule
{
}
